import { all } from "redux-saga/effects";
import productSaga from "../reduxSetup/productSaga";

export default function* rootSaga() {
  yield all([productSaga()]);
}
